import React from 'react'
import Slider from 'react-slick'

import Item from './Item'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ],
  dotsClass: 'slick-dots slick-circle',
  customPaging: (i) => <span />
}

const Profiles = ({ profiles }) => (
  <section className='padding-tb-100px sm-pt-35px'>
    <div className='container'>
      <div className='row justify-content-center'>
        <div className='col-lg-7'>
          <div className='firo-title dark text-center wow fadeInUp' data-wow-delay='0.2s'>
            <h2 className='title'>Community</h2>
            <div className='description'>Space dedicated to celebrate key people in the Node.js ecosystem</div>
          </div>
        </div>
      </div>
      <Slider {...settings}>
        {
          profiles.map(({ node }, index) => <Item key={index} {...node} />)
        }
      </Slider>
    </div>
  </section>
)

export default Profiles
